// class UrgencyTimer extends HTMLElement {
//   constructor() {
//     super();
//     this.timerContainer = null;
//     this.dateDisplay = null;
//     this.interval = null;
//     this.targetTime = null;
//   }

//   connectedCallback() {
//     this.timerContainer = this.querySelector('#urgency_timer');
//     this.dateDisplay = this.querySelector('#dynamic_current_date');

//     // Get future date from Shopify Customizer
//     const futureDateAttr = this.getAttribute('data-future-date');
//     if (!futureDateAttr) {
//       console.error('❌ Missing data-future-date attribute.');
//       return;
//     }

//     const targetDate = new Date(futureDateAttr);
//     if (isNaN(targetDate.getTime())) {
//       console.error('❌ Invalid future date format. Use: YYYY-MM-DDTHH:MM:SS');
//       return;
//     }

//     this.targetTime = targetDate.getTime();

//     if (this.dateDisplay) {
//       this.dateDisplay.textContent = this.formatDate(targetDate);
//     }

//     this.startTimer();
//   }

//   startTimer() {
//     this.updateTimer();
//     // Update once per minute instead of every second
//     this.interval = setInterval(() => {
//       const now = new Date().getTime();
//       const distance = this.targetTime - now;

//       if (distance <= 0) {
//         clearInterval(this.interval);
//         this.renderZeroState();
//       } else {
//         this.updateTimer();
//       }
//     }, 60000); // 60 seconds
//   }

//   updateTimer() {
//     const now = new Date().getTime();
//     const distance = this.targetTime - now;

//     const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//     const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//     const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

//     const displayDays = String(days).padStart(2, '0');
//     const displayHours = String(hours).padStart(2, '0');
//     const displayMinutes = String(minutes).padStart(2, '0');

//     if (this.timerContainer) {
//       this.timerContainer.innerHTML = `
//         <div class="time-block">
//           <span class="time-value">${displayDays}</span>
//           <span class="time-unit">D</span>
//         </div>
//         <div class="time-block">
//           <span class="time-value">${displayHours}</span>
//           <span class="time-unit">H</span>
//         </div>
//         <div class="time-block">
//           <span class="time-value">${displayMinutes}</span>
//           <span class="time-unit">M</span>
//         </div>
//       `;
//     }
//   }

//   renderZeroState() {
//     if (this.timerContainer) {
//       this.timerContainer.innerHTML = `
//         <div class="time-block">
//           <span class="time-value">00</span>
//           <span class="time-unit">D</span>
//         </div>
//         <div class="time-block">
//           <span class="time-value">00</span>
//           <span class="time-unit">H</span>
//         </div>
//         <div class="time-block">
//           <span class="time-value">00</span>
//           <span class="time-unit">M</span>
//         </div>
//       `;
//     }
//   }

//   formatDate(date) {
//     const months = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
//     const month = months[date.getMonth()];
//     const day = date.getDate();
//     const year = date.getFullYear();
//     return `${month} ${day}, ${year}`;
//   }
// }

// customElements.define('custom-deliver-order', UrgencyTimer);
class UrgencyTimer extends HTMLElement {
  constructor() {
    super();
    this.timerContainer = null;
    this.dateDisplay = null;
    this.interval = null;
    this.targetTime = null;
  }

  connectedCallback() {
    this.timerContainer = this.querySelector('#urgency_timer');
    this.dateDisplay = this.querySelector('#dynamic_current_date');

    const futureDateAttr = this.getAttribute('data-future-date');

    if (!futureDateAttr) {
      console.error('❌ Missing data-future-date attribute.');
      return;
    }

    const targetDate = new Date(futureDateAttr);

    if (isNaN(targetDate.getTime())) {
      console.error('❌ Invalid date format. Use YYYY-MM-DDTHH:MM:SS');
      return;
    }

    this.targetTime = targetDate.getTime();

    // Update date on UI
    if (this.dateDisplay) {
      this.dateDisplay.textContent = this.formatDate(targetDate);
    }

    this.startTimer();
  }

  startTimer() {
    this.updateTimer();

    // Update every 1 second for smooth seconds countdown
    this.interval = setInterval(() => {
      const now = Date.now();
      const distance = this.targetTime - now;

      if (distance <= 0) {
        this.classList.add("hide");
        clearInterval(this.interval);
        this.renderZeroState();
      } else {
        this.classList.remove("hide");
        this.updateTimer();
      }
    }, 1000);
  }

  updateTimer() {
    const now = Date.now();
    const distance = this.targetTime - now;

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const display = {
      days: String(days).padStart(2, '0'),
      hours: String(hours).padStart(2, '0'),
      minutes: String(minutes).padStart(2, '0'),
      seconds: String(seconds).padStart(2, '0'),
    };

    if (this.timerContainer) {
      this.timerContainer.innerHTML = `
        <div class="time-block">
          <span class="time-value">${display.days}</span>
          <span class="time-unit">D</span>
        </div>
        <div class="time-block">
          <span class="time-value">${display.hours}</span>
          <span class="time-unit">H</span>
        </div>
        <div class="time-block">
          <span class="time-value">${display.minutes}</span>
          <span class="time-unit">M</span>
        </div>
        <div class="time-block">
          <span class="time-value">${display.seconds}</span>
          <span class="time-unit">S</span>
        </div>
      `;
    }
  }

  renderZeroState() {
      // Hide the entire timer block when time is up
     this.style.display = 'none';
    if (this.timerContainer) {
      this.timerContainer.innerHTML = `
        <div class="time-block">
          <span class="time-value">00</span>
          <span class="time-unit">D</span>
        </div>
        <div class="time-block">
          <span class="time-value">00</span>
          <span class="time-unit">H</span>
        </div>
        <div class="time-block">
          <span class="time-value">00</span>
          <span class="time-unit">M</span>
        </div>
        <div class="time-block">
          <span class="time-value">00</span>
          <span class="time-unit">S</span>
        </div>
      `;
    }
  }

  formatDate(date) {
    const months = ["Jan.", "Feb.", "Mar.", "Apr.", "May", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
    return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
  }
}

customElements.define('custom-deliver-order', UrgencyTimer);


const rewamped_featured_cards_array = document.querySelectorAll("[data-cards-layout='carousel']");

rewamped_featured_cards_array.forEach(element => {

  const container_section_id = element.getAttribute("data-featured-collection-layout");
  const section_id = element.getAttribute("data-rewamped-featured-id");

  const section_container = document.querySelector(
    `[data-section-id="${section_id}"]`
  );

  const swiper_carousel_container = document.querySelector(
    `[data-featured-collection-layout='${container_section_id}']`
  );

  const swiper_container = new Swiper(swiper_carousel_container, {
    loop: true,
    spaceBetween: 32,
    navigation: {
      nextEl: section_container.querySelector('.swiper-button-next'),
      prevEl: section_container.querySelector('.swiper-button-prev'),
    },
    scrollbar: {
      el: section_container.querySelector('.swiper-scrollbar')
    },
    breakpoints: {
      0: {
        slidesPerView: 1.25,
        spaceBetween: 16,
      },
      480: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3,
        scrollbar: false
      },
      1200: {
        slidesPerView: 4,
        scrollbar: false,
        grid: {
          rows: 1
        }
      }
    }
  });
});




const featured_reviews_carousels = document.querySelectorAll("[data-reviews-layout='carousel']");

featured_reviews_carousels.forEach(carousel => {

  const section_id = carousel.getAttribute("data-featured-reviews-id");
  const section_container = document.querySelector(`[data-section-id="${section_id}"]`);

  const swiper_container = new Swiper(carousel, {
    loop: false,
    spaceBetween: 32,
    effect: "slide",
    navigation: {
      nextEl: section_container.querySelector(".swiper-button-next"),
      prevEl: section_container.querySelector(".swiper-button-prev"),
    },
    scrollbar: {
      el: section_container.querySelector(".swiper-scrollbar")
    },
    breakpoints: {
      0: {
        slidesPerView: 1.25,
        spaceBetween: 16
      },
      540: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3,
        scrollbar: false
      },
      1200: {
        slidesPerView: 3,
        scrollbar: false
      },
    },
  });

});


  document.addEventListener('DOMContentLoaded', function() {
    // Initialize Swiper Carousel
    const worn_loved_carousel_array = document.querySelectorAll("[data-videos-layout='carousel']");

    worn_loved_carousel_array.forEach(carousel => {
      const section_id = carousel.getAttribute("data-featured-reviews-id");
      const section_container = document.querySelector(`[data-section-id="${section_id}"]`);

      const swiper_container = new Swiper(carousel, {
        loop: false,
        spaceBetween: 32,
        effect: "slide",
        navigation: {
          nextEl: section_container.querySelector(".swiper-button-next"),
          prevEl: section_container.querySelector(".swiper-button-prev"),
        },
        scrollbar: {
          el: section_container.querySelector(".swiper-scrollbar")
        },
        breakpoints: {
          0: {
            slidesPerView: 1.25,
            spaceBetween: 16
          },
          540: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3,
            scrollbar: false
          },
          1200: {
            slidesPerView: 3,
            scrollbar: false
          },
        },
      });
    });

    // Video Play/Pause Functionality
    const videoContainers = document.querySelectorAll('.worn-and-loved-section [data-video-container]');
    
    videoContainers.forEach(container => {
      const video = container.querySelector('video');
      const playButton = container.querySelector('[data-play-button]');
      
      if (video && playButton) {
        playButton.addEventListener('click', function(e) {
          e.preventDefault();
          
          if (video.paused) {
            video.play();
            video.setAttribute('controls', 'controls');
            container.classList.add('playing');
          }
        });

        video.addEventListener('pause', function() {
          container.classList.remove('playing');
        });

        video.addEventListener('ended', function() {
          video.removeAttribute('controls');
          container.classList.remove('playing');
        });
      }
    });


  });


// rwc-section

const rwc_section_carousels = document.querySelectorAll("[data-rwc-section-cards-layout='carousel']");

rwc_section_carousels.forEach(carousel => {

  const section_id = carousel.getAttribute("data-rwc-section-id");
  const section_container = document.querySelector(`.richtext-with-collection-section-${section_id}`);

  const swiper_container = new Swiper(carousel, {
    loop: false,
    spaceBetween: 32,
    effect: "slide",
    navigation: {
      nextEl: section_container.querySelector(".swiper-button-next"),
      prevEl: section_container.querySelector(".swiper-button-prev"),
    },
    scrollbar: {
      el: section_container.querySelector(".swiper-scrollbar")
    },
    breakpoints: {
      0: {
        slidesPerView: 1.25,
        spaceBetween: 16
      },
      540: {
        slidesPerView: 1.4
      },
      768: {
        slidesPerView: 1
      },
      1280: {
        slidesPerView: 1.8
      },
      1440: {
        slidesPerView: 3,
        scrollbar: false
      },
    },
  });

});

document.addEventListener("scroll", () => {
  if (window.scrollY > 160) {
    document.body.classList.add("scrolling");
  } else {
    document.body.classList.remove("scrolling");
  }
});
